import React from 'react';

const TronContext = React.createContext();

export default TronContext;